import { DbConnection } from '../db/index';
import './components/FactoryScene';

// Initialize SpacetimeDB connection
function initSpacetimeDB() {
  // Create a forest scene component
  const gameContainer = document.getElementById('game-container');
  const loadingEl = document.getElementById('loading');
  const factoryScene = document.createElement('factory-scene');
  
  if (gameContainer) {
    gameContainer.appendChild(factoryScene);
  }
  
  // Remove loading message once scene is added
  if (loadingEl) {
    loadingEl.style.display = 'none';
  }
  
  // Function to subscribe to database queries
  const subscribeToQueries = (conn: any, queries: string[]) => {
    let count = 0;
    for (const query of queries) {
      conn
        ?.subscriptionBuilder()
        .onApplied(() => {
          count++;
          if (count === queries.length) {
            console.log('SDK client cache initialized.');
          }
        })
        .subscribe(query);
    }
  };

  // Function to set user name
  const setUserName = (conn: any) => {
    // Get name from local storage or prompt user
    let username = localStorage.getItem('username');
    
    if (!username) {
      username = prompt('Enter your name:', 'Factory Visitor') || 'Anonymous';
      localStorage.setItem('username', username);
    }
    
    // Set the user name in SpacetimeDB
    try {
      conn.reducers.setName(username);
      console.log(`Username set to: ${username}`);
    } catch (e) {
      console.error('Failed to set username:', e);
    }
  };

  // Handler for successful connection
  const onConnect = (conn: any, identity: any, token: string) => {
    console.log('Connected to SpacetimeDB with identity:', identity.toHexString());
    
    // Store identity token
    localStorage.setItem('auth_token', token);
    
    // Set user name
    setUserName(conn);
    
    // Subscribe to User table
    subscribeToQueries(conn, [
      'SELECT * FROM User'
    ]);
    
    // Connect the factory scene to SpacetimeDB
    if ('connectToSpacetimeDB' in factoryScene) {
      (factoryScene as any).connectToSpacetimeDB(conn);
    }
    
    console.log('LetterCraft client initialized successfully');
  };

  // Handler for disconnection
  const onDisconnect = () => {
    console.log('Disconnected from SpacetimeDB');
    
    // Show disconnection message
    if (loadingEl) {
      loadingEl.style.display = 'block';
      loadingEl.innerHTML = `
        <h1>Disconnected</h1>
        <p>Connection to the factory lost. Attempting to reconnect...</p>
      `;
    }
  };

  // Handler for connection errors
  const onConnectError = (_: any, err: Error) => {
    console.error('Error connecting to SpacetimeDB:', err);
    
    // Show error in UI
    if (loadingEl) {
      loadingEl.style.display = 'block';
      loadingEl.innerHTML = `
        <h1>Connection Error</h1>
        <p>Failed to connect to the factory. Please try again later.</p>
        <pre>${err.message}</pre>
      `;
    }
  };

  // Build the SpacetimeDB connection
  return DbConnection.builder()
    .withUri('ws://localhost:3000')
    .withModuleName('lettercraft')
    .withToken(localStorage.getItem('auth_token') || '')
    .onConnect(onConnect)
    .onDisconnect(onDisconnect)
    .onConnectError(onConnectError)
    .build();
}

// Entry point
function main() {
  try {
    // Initialize SpacetimeDB
    initSpacetimeDB();
    console.log('SpacetimeDB connection initialized');
  } catch (error) {
    console.error('Failed to initialize LetterCraft client:', error);
    
    // Show error in UI
    const loadingEl = document.getElementById('loading');
    if (loadingEl) {
      loadingEl.innerHTML = `
        <h1>Initialization Error</h1>
        <p>Failed to initialize the factory client.</p>
        <pre>${error instanceof Error ? error.message : String(error)}</pre>
      `;
    }
  }
}

// Start the application
main(); 